export enum ESignWorkflowSessionStatus {
  INITIALIZING = "INITIALIZING",
  READY = "READY",
  START = "START",
  SIGNED = "SIGNED",
  COMPLETED = "COMPLETED",
  ERRORED = "ERRORED",
  INVALIDATED = "INVALIDATED",
}

export const NON_SIGNABLE_ESIGN_WORKFLOW_SESSION_STATUSES = [
  ESignWorkflowSessionStatus.ERRORED,
  ESignWorkflowSessionStatus.INVALIDATED,
  ESignWorkflowSessionStatus.COMPLETED,
  ESignWorkflowSessionStatus.SIGNED,
] as const;
